/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

import { observer } from 'mobx-react';
import { IFarmlandsHeaderResources } from '../farmlands-header.props.autogenerated';

export interface INavIconProps {
    resources: IFarmlandsHeaderResources;
    isExpanded: boolean;
    targetId: string;
    toggleNavBar(): void;
}

/**
 *
 * NavIcon component
 * @extends {React.PureComponent<INavIconProps>}
 */

@observer
export class NavIcon extends React.Component<INavIconProps> {
    public render(): JSX.Element {
        return (
            <span
                className='ms-header__nav-icon material-icons'
                onClick={this.props.toggleNavBar}
                title={this.props.resources.mobileHamburgerAriaLabel}
                aria-label={this.props.resources.mobileHamburgerAriaLabel}
                aria-expanded={this.props.isExpanded}
                aria-controls={this.props.targetId}
                role='button'
            >
                {this.props.isExpanded ? 'close' : 'menu'}
            </span>
        );
    }
}
